export const changeQuantityProduct = (trxId, pharmacy, products) => {
	return {
		trx_id: trxId,
		pharmacy: pharmacy,
		products: products
	};
};
